import React, { ErrorInfo } from 'react';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';
import { getErrorMessage } from 'lib/utils/common/getErrorMessage';

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  error: Error | null;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
    // console.log('Uncaught error:', _error);
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    const errorMessage = getErrorMessage(error);
    return (
      <>
        <ErrorModal
          message={errorMessage}
          // onClose={() => this.setState({ error: null })}
          onClose={() => {
            if (error.name === 'ChunkLoadError') {
              window.location.reload();
              // console.log('reload');
            } else {
              // console.log('close error');
              this.setState({ error: null });
            }
          }}
        />
        {/* {console.log(this.state)} */}
      </>
    );
  }
}

export { ErrorBoundary };
